import React from 'react';
import { Box, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';

import { MaterialPropertyValuePair } from '@paragon/client-tools';
import { DistanceField } from '@paragon/material';

import { updateInsertionCornerSet } from '../../../../../store/actions/layout/trussEnvelopeActions';
import { isLayoutBasedOnRoofContainers } from '../../../../../store/selectors/layoutModeSelectors';
import { InsertingCornerSetInfo } from '../../../../../store/slices/applicationSlice';
import { PlanePickerField } from '../../../../controls/PlanePickerField';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import InsertionPanelContainer from '../InsertionPanelContainer';

export function CornerSetInsertionSubPanel() {
  const dispatch = useAppDispatch();

  const inRoofContainerLayout = useAppSelector(isLayoutBasedOnRoofContainers);
  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);
  const trussEnvelopes = useAppSelector((state) => state.layout.trussEnvelopes);
  const componentDesigns = useAppSelector((state) => state.componentDesigns.data);

  if (inRoofContainerLayout) return null; // Roof container layouts are not yet supported by the corner set tool.
  if (insertingObjectInfo?.type !== 'cornerSet') return null;

  const { type, spacing, plane1Guid = null, plane2Guid = null, girderGuid, minJackLength } = insertingObjectInfo.data;

  const girderEnvelope = trussEnvelopes[girderGuid];
  const girderName = girderEnvelope.componentDesignGuid
    ? componentDesigns[girderEnvelope.componentDesignGuid].component.name
    : girderEnvelope.name;

  return (
    <InsertionPanelContainer hideSubmitButton>
      <Box sx={{ padding: 1, marginBottom: 2 }}>
        <Typography align="center" variant="h5" sx={{ marginBottom: 2 }}>
          Create Corner Set
        </Typography>

        <Stack direction="column" spacing={1}>
          <RadioGroup
            row
            value={type}
            onChange={(_, type) =>
              dispatch(updateInsertionCornerSet({ type: type as InsertingCornerSetInfo['data']['type'] }))
            }
          >
            <FormControlLabel sx={{ m: 0 }} value="Stepdown" control={<Radio />} label="Stepdown" />
            <FormControlLabel sx={{ ml: 1 }} value="Atlantic" control={<Radio />} label="Atlantic" />
          </RadioGroup>
          <DistanceField
            label="Envelope Spacing"
            value={spacing}
            onSubmit={(spacing) => dispatch(updateInsertionCornerSet({ spacing }))}
          />
          <DistanceField
            label="Minimum Jack Length"
            value={minJackLength}
            onSubmit={(minJackLength) => dispatch(updateInsertionCornerSet({ minJackLength }))}
          />
          <PlanePickerField label="First Roof Plane" target={{ type: 'corner-set-plane-1' }} value={plane1Guid} />
          <PlanePickerField label="Second Roof Plane" target={{ type: 'corner-set-plane-2' }} value={plane2Guid} />
          <MaterialPropertyValuePair property="Girder" value={girderName} />
        </Stack>
      </Box>
    </InsertionPanelContainer>
  );
}
